import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import ConfigAPI from '@/config/api'
import Session from '@/handler/session'

Vue.use(VueAxios, axios)

const instance = axios.create();

const servicesAPI = {
  obtenerPedido() {
    var url = ConfigAPI.baseURL + "orders" + Session.getToken();
    return instance.get(url);
  },
  mostrarPedido(id) {
    var url = ConfigAPI.baseURL + "orders/" + id + Session.getToken();
    return instance.get(url);
  },
  agregarPedido(data) {    
    var params = data
    var url = ConfigAPI.baseURL + "orders" + Session.getToken();
    return instance.post(url,params);
  },
  editarPedido(data) {    
    var params = data    
    var url = ConfigAPI.baseURL + "orders/"+ data.id + Session.getToken();
    return instance.post(url,params);
  },
  eliminarPedido(id) {
    var url = ConfigAPI.baseURL + "orders/"+ id + Session.getToken();
    return instance.delete(url);
  },
  logSyncError(data) {
    var url = ConfigAPI.baseURL + "orders-sync-errors" + Session.getToken();
    return instance.post(url, data);
  },
  deleteSyncErrors(idempotencyKey) {
    var url = ConfigAPI.baseURL + "orders-sync-errors/" + encodeURIComponent(idempotencyKey) + Session.getToken();
    return instance.delete(url);
  },
  filtrarPedido(data, page) {
    var params = data    
    var url = ConfigAPI.baseURL + "orders/filter/query" + Session.getToken() + "&page=" + page;
    return instance.post(url,params);
  },  
  cambiarEstadoPedido(data, compactResponse = false) {
    var params = compactResponse ? Object.assign({}, data, { compact_response: true }) : data
    var url = ConfigAPI.baseURL + "orders/change/status" + Session.getToken();
    return instance.post(url,params);
  },
  cambiarPago(data, compactResponse = false) {
    var params = compactResponse ? Object.assign({}, data, { compact_response: true }) : data
    var url = ConfigAPI.baseURL + "orders/change/paid" + Session.getToken();
    return instance.post(url,params);    
  },
  getLinkPago(data) {
    var params = data    
    var url = ConfigAPI.baseURL + "orders/get/link" + Session.getToken();
    return instance.post(url,params);    
  },
  trackingPedido(data, compactResponse = false) {
    var params = compactResponse ? Object.assign({}, data, { compact_response: true }) : data
    var url = ConfigAPI.baseURL + "orders/change/status/in_transport" + Session.getToken();
    return instance.post(url,params);        
  },
  changeNroOrderInternal(data, compactResponse = false) {
    var params = compactResponse ? Object.assign({}, data, { compact_response: true }) : data
    var url = ConfigAPI.baseURL + "orders/change/nro_order_internal" + Session.getToken();
    return instance.post(url,params);    
  },
  changeNameProduct(data) {
    var params = data    
    var url = ConfigAPI.baseURL + "ordersDetail/" + data.id + Session.getToken();
    return instance.post(url,params);    
  },
  sendEmailOrder(data) {
    var params = data    
    var url = ConfigAPI.baseURL + "orders/send/email" + Session.getToken();
    return instance.post(url,params);    
  },  
  obtenerClientesByZonas(data) {
    var params = data
    var url = ConfigAPI.baseURL + "sellers/filter/customerByZone" + Session.getToken();
    return instance.post(url,params);
  },
  obtenerZonasConClientes(data) {
    var params = data
    var url = ConfigAPI.baseURL + "sellers/filter/zonesWithCustomersBySeller" + Session.getToken();
    return instance.post(url,params);
  },

  obtenerConfiguracion(config) {
    var url = ConfigAPI.baseURL + "orders-configuration" + Session.getToken();
    return instance.get(url, config);
  },
  saveConfiguracion(data) {
    var params = data
    var url = ConfigAPI.baseURL + "orders-configuration/" + data.id + Session.getToken();
    return instance.post(url,params);
  },  

  obtenerClientes() {
    var url = ConfigAPI.baseURL + "customers" + Session.getToken();
    return instance.get(url);
  },
  mostrarCliente(id) {
    var url = ConfigAPI.baseURL + "customers/" + id + Session.getToken();
    return instance.get(url);
  },  
  obtenerVendedores() {
    var url = ConfigAPI.baseURL + "sellers" + Session.getToken();
    return instance.get(url);
  },  
  obtenerPuntosVentas() {
    var url = ConfigAPI.baseURL + "sales-points-sales" + Session.getToken();
    return instance.get(url);
  },    
  obtenerMetodosPagos() {
    var url = ConfigAPI.baseURL + "sales-methods-payment" + Session.getToken();
    return instance.get(url);
  },
  
  integratedManufactureSystemPedido(data) {
    var params = data.data
    var url = data.url;
    return instance.post(url,params);
  },
  cambiarEstadoPedidoEnPreparacion(data, compactResponse = false) {
    var params = compactResponse ? Object.assign({}, data, { compact_response: true }) : data
    var url = ConfigAPI.baseURL + "orders/change/status/in_preparation" + Session.getToken();
    return instance.post(url,params);        
  },
  cambiarEstadoSistemaProduccion(data, compactResponse = false) {
    var params = compactResponse ? Object.assign({}, data, { compact_response: true }) : data
    var url = ConfigAPI.baseURL + "orders/change/statusSystemManufacture" + Session.getToken();
    return instance.post(url,params);        
  },  


  obtenerMotivos() {
    var url = ConfigAPI.baseURL + "orders-reason" + Session.getToken();
    return instance.get(url);
  },
  mostrarMotivos(id) {
    var url = ConfigAPI.baseURL + "orders-reason/" + id + Session.getToken();
    return instance.get(url);
  },
  agregarMotivos(data) {    
    var params = data
    var url = ConfigAPI.baseURL + "orders-reason" + Session.getToken();
    return instance.post(url,params);
  },
  editarMotivos(data) {    
    var params = data    
    var url = ConfigAPI.baseURL + "orders-reason/"+ data.id + Session.getToken();
    return instance.post(url,params);
  },
  eliminarMotivos(id) {
    var url = ConfigAPI.baseURL + "orders-reason/"+ id + Session.getToken();
    return instance.delete(url);
  }, 
  filtrarMotivos(data, page) {
    var params = data    
    var url = ConfigAPI.baseURL + "orders-reason/filter/query" + Session.getToken() + "&page=" + page;
    return instance.post(url,params);
  },    

  eliminarAdjunto(id) {
    var url = ConfigAPI.baseURL + "orders-attach/"+ id + Session.getToken();
    return instance.delete(url);
  },
  agregarObservacion(data) {
    var params = data
    var url = ConfigAPI.baseURL + "reports-news" + Session.getToken();
    return instance.post(url, params);
  },
  agregarCobranza(data) {
    var params = data
    var url = ConfigAPI.baseURL + "reports-payment" + Session.getToken();
    return instance.post(url, params);
  },
  filtrarCobranzasHoy(data) {
    var params = data
    var url = ConfigAPI.baseURL + "reports-payment/filter/query" + Session.getToken() + "&page=1";
    return instance.post(url, params);
  },
  filtrarObservacionesHoy(data) {
    var params = data
    var url = ConfigAPI.baseURL + "reports-news/filter/query" + Session.getToken() + "&page=1";
    return instance.post(url, params);
  },

  // Recursos de otros módulos (Precios, Productos, Ventas) que necesita el
  // armado de pedidos mobile. Cada módulo tiene su propio wrapper acá adentro
  // en vez de llamar a la API directo desde el .vue, aunque el endpoint ya
  // esté usado por otro módulo (ver purchase/staff/services.js:obtenerIvaCondition
  // y costs/staff/services.js:obtenerCondicionesIva para el mismo criterio).
  obtenerListasPrecios() {
    var url = ConfigAPI.baseURL + "price-list" + Session.getToken();
    return instance.get(url);
  },
  filtrarListasPrecios(data) {
    var params = data
    var url = ConfigAPI.baseURL + "price-list/find/control/controlByFilter" + Session.getToken();
    return instance.post(url, params);
  },
  obtenerProductosListaPrecio(data) {
    var params = data
    var url = ConfigAPI.baseURL + "price-list-products/filter/getProducts" + Session.getToken();
    return instance.post(url, params);
  },
  filtrarProductos(data) {
    var params = data
    var url = ConfigAPI.baseURL + "products/find/control/controlByFilter" + Session.getToken();
    return instance.post(url, params);
  },
  mostrarProductoControl(id, data) {
    var params = data
    var url = ConfigAPI.baseURL + "products/find/control/controlShow/" + id + Session.getToken();
    return instance.post(url, params);
  },
  obtenerPrecioProducto(data) {
    var params = data
    var url = ConfigAPI.baseURL + "products/get/price" + Session.getToken();
    return instance.post(url, params);
  },
  obtenerUnidadesMedida(data) {
    var params = data
    var url = ConfigAPI.baseURL + "products-unit-measurement/find/control/controlByFilter" + Session.getToken();
    return instance.post(url, params);
  },
  obtenerCondicionesIva() {
    var url = ConfigAPI.baseURL + "sales-iva-conditions" + Session.getToken();
    return instance.get(url);
  },
}

export default servicesAPI;
